import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7323323f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "middle" }
const _hoisted_2 = { class: "middle-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "真实姓名", -1))
const _hoisted_4 = { class: "middle-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "身份证号", -1))
const _hoisted_6 = { class: "middle-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "middle-item-title" }, "手机号", -1))
const _hoisted_8 = { class: "button" }

import AppHeader from '@/components/Header.vue'
import { Field, Divider, Button, Toast } from 'vant'
import { ref, onMounted, Ref, withDefaults } from 'vue'
import { AxiosError } from 'axios'
import { useRouter, useRoute } from 'vue-router'
import { getServiceList, modifyOperator } from '@/apis/three-liability-insurance'
import { useStore } from 'vuex'
import { serviceItem, OperatorItemType } from '@/types/three-liability-insurance'
import appHost from '@/utils/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'add-operator',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };

const onLeftClick = function () {
  appHost.goAppBack()
}


let pageTitle = ref('')
let operator_list: Ref<OperatorItemType[]> = ref([])
let operator: Ref<OperatorItemType> = ref({
  name: '',
  id_card: '',
  phone: '',
  old_id_card: '',
  status: 'A',
  mobile: '',
})
const submitLoading = ref(false)
const router = useRouter()
const route = useRoute()
let sn = route.query.sn as string
let currentIndex = route.query.currentIndex
const cacheKey = route.query.cacheKey as string
const store = useStore()
const updated_by = store.state.userInfo.realName
let policy_no = ref('')
let currentOperateText = currentIndex === undefined ? '添加' : '修改'
pageTitle.value = currentIndex === undefined ? '添加操作员信息' : '修改操作员信息'
if (currentIndex) {
  operator.value.status = 'U'
}
async function submit() {
  submitLoading.value = true
  try {
    // Toast({
    //   message: `${currentOperateText}中...`,
    //   duration: 0,
    // })
    let index = currentIndex === undefined ? operator_list.value.length : currentIndex
    operator_list.value.splice(Number(index), 1, operator.value)
    await modifyOperator({
      policy_no: policy_no.value,
      updated_by,
      operator_list: operator_list.value,
    })
  } catch (e) {
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    submitLoading.value = false
    return
  }
  // Toast.clear()
  Toast.success(`${currentOperateText}成功`)
  submitLoading.value = false
  sessionStorage.removeItem(cacheKey)
  setTimeout(() => {
    router.go(-1)
  }, 2000)
}

onMounted(async () => {
  try {
    Toast.loading({
      message: `加载中...`,
      duration: 0,
    })
    const cacheDataStr = sessionStorage.getItem(cacheKey)
    let data =
      cacheDataStr && cacheDataStr !== 'null'
        ? (JSON.parse(cacheDataStr) as serviceItem)
        : await getServiceList({ sn })
    policy_no.value = data.policy_no
    console.log('data', data)
    operator_list.value = JSON.parse(data.operator).map((item: OperatorItemType) => ({
      ...item,
      status: 'U',
      old_id_card: item.id_card,
    }))
    if (currentIndex !== undefined) {
      operator.value = operator_list.value[Number(currentIndex)]
    }
    Toast.clear()
    console.log('data', data)
  } catch (e) {
    console.log('e', e)
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    router.go(-1)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: _unref(pageTitle),
      onLeftClick: onLeftClick
    }, null, 8, ["title"]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", props.displayMode === 'Landscape' ? 'landscape-width' : ''])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: _unref(operator).name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(operator).name) = $event)),
            modelModifiers: { trim: true },
            placeholder: "必填，请与操作员证件姓名一致"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: _unref(operator).id_card,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(operator).id_card) = $event)),
            modelModifiers: { trim: true },
            placeholder: "必填，请正确填写操作员的证件号"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } }),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Field), {
            style: {"font-size":"16px","line-height":"24px"},
            modelValue: _unref(operator).phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(operator).phone) = $event)),
            modelModifiers: { trim: true },
            placeholder: "必填，请正确填写操作员的手机号"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Button), {
          color: "#02c37b",
          style: {
          width: '100%',
          height: '48px',
          background: '#00C378',
          borderRadius: '8px',
          footWeight: 500,
          fontSize: '16px',
          lineHeight: '24px',
        },
          onClick: submit,
          "loading-type": "spinner",
          loading: submitLoading.value,
          disabled: submitLoading.value,
          "loading-text": "请稍候"
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ], 2)
  ], 64))
}
}

})